<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half Title">
<p class="halftitle"><span class="right_1" epub:type="pagebreak" id="page_xxxi" title="xxxi"><b><span class="small">THE BATTLE FOR MALAYA</span></b><span class="right_1" epub:type="pagebreak" id="page_xxxii" title="xxxii"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044174_Halftitle1_.vue?80e76fd2